import { formatDate, getUtcDate } from '@chillibean/component-library';
import { useDispatch, useSelector } from 'react-redux';

import { setFilteringChips } from '../../redux/actions';

export function useFilterChips() {
  const CURRENT_TIMEZONE = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || 'UTC';
  const dispatch = useDispatch();
  const filterDefinitions = useSelector((state) => state.filteringReducer);
  const {
    filteringActions: { data: filterActions },
    filteringLocations: { data: filterLocations },
    filteringPerformers: { data: filterPerformers },
  } = filterDefinitions;

  const formatFilterChips = (paramsObject) => {
    const chips = [];
    if (paramsObject.actions) {
      const splitActions = paramsObject.actions.split(',');
      splitActions.forEach((action) => {
        const actionObject = filterActions.find((a) => a.findByValue(action));
        if (actionObject) {
          chips.push({
            id: actionObject.value.toString(),
            type: 'actions',
            value: `Action: ${actionObject.name}`,
          });
        }
      });
    }

    if (paramsObject.location_id) {
      const splitLocation = paramsObject.location_id.split(',');
      splitLocation.forEach((location) => {
        const [locationType, locationId] = location.split('-');
        const locationObject = filterLocations.find((l) => l.findByIdAndType(parseInt(locationId, 10), locationType));
        if (locationObject) {
          chips.push({
            id: locationObject.multiSelectParams().value.toString(),
            type: 'locations',
            value: `Location: ${locationObject.name}`,
          });
        }
      });
    }

    if (paramsObject.performer_id) {
      const splitPerformerIds = paramsObject.performer_id.split(',');
      splitPerformerIds.forEach((performerId) => {
        const performerObject = filterPerformers.find((p) => p.findById(parseInt(performerId, 10)));
        if (performerObject) {
          chips.push({
            id: performerObject.id.toString(),
            type: 'performers',
            value: `Peformer: ${performerObject.fullName()}`,
          });
        }
      });
    }

    if (paramsObject.date_from) {
      const fromDate = paramsObject.date_from.replace(' ', '+');
      const utcDate = getUtcDate(fromDate, CURRENT_TIMEZONE);
      let formattedDateFrom;
      try {
        formattedDateFrom = formatDate(utcDate, 'dd MMM yyyy');
      } catch (e) {
        formattedDateFrom = fromDate;
      }
      chips.push({
        id: paramsObject.date_from,
        type: 'date_from',
        value: `From: ${formattedDateFrom}`,
      });
    }

    if (paramsObject.date_to) {
      const toDate = paramsObject.date_to.replace(' ', '+');
      const utcDate = getUtcDate(toDate, CURRENT_TIMEZONE);
      let formattedDateTo;
      try {
        formattedDateTo = formatDate(utcDate, 'dd MMM yyyy');
      } catch (e) {
        formattedDateTo = toDate;
      }
      chips.push({
        id: paramsObject.date_to,
        type: 'date_to',
        value: `To: ${formattedDateTo}`,
      });
    }

    dispatch(setFilteringChips({ data: chips }));
  };

  return { formatFilterChips };
}

export default useFilterChips;
